<div class="dialog-header">
  <div class="header-title">
    <span class="header-span">{{headerTitle}}</span>
  </div>
  <button mat-button class="close-button-container" disableRipple="true" (click)="closeDialog()">
    <mat-icon>clear</mat-icon>
  </button>
</div>

<div class="middle-content" *ngIf="!typeLoading">
  <div class="inputs-block">
    <div class="input-block">
      <div class="input-label">Name:</div>

      <div class="email-input-text">
        <input class="arrow-input" type="text" pInputText BlockLateralArrowNavigation
               [ngModelOptions]="{standalone: true}" [(ngModel)]="tempFee.name">
      </div>
    </div>
    <div class="input-block">
      <div class="input-label">Base Price:</div>

      <div class="email-input-text">
        <p-inputNumber class="arrow-input value-input-number"
                       [ngModelOptions]="{standalone: true}"
                       [(ngModel)]="tempFee.basePrice" mode="decimal" [minFractionDigits]="1"
                       [maxFractionDigits]="2"></p-inputNumber>
      </div>
    </div>

    <div class="input-block">
      <div class="input-label">Type:</div>

      <div class="email-input-text">
        <p-dropdown [options]="types" [(ngModel)]="tempFee.type"
                    placeholder="Type" appendTo="body" panelStyleClass="p-modifier-dropdown-panel"
                    (ngModelChange)="fillConditionsTable()">
        </p-dropdown>
      </div>
    </div>
    <ng-container *ngIf="tempFee.type !== 'DELIVERY'">
      <div class="input-block">
        <div class="input-label">Anchor:</div>

        <div class="email-input-text">
          <p-dropdown [options]="anchors" [(ngModel)]="tempFee.anchor"
                      placeholder="Anchor" appendTo="body" panelStyleClass="p-modifier-dropdown-panel">

          </p-dropdown>
        </div>
      </div>
      <div class="input-block">
        <div class="input-label">Conditions
          <button mat-button (click)="addNewLine()" class="new-item-button">New Condition</button>
        </div>

        <div class="email-input-text">
          <div #conditionTable class="sheet-table">

          </div>

        </div>
      </div>

      <div class="input-block">
        <div class="input-label">For First Area:</div>


        <div class="boxes-block">
          <p-inputSwitch class="arrow-input" [ngModelOptions]="{standalone: true}"
                         [disabled]="loadingSpinner" [(ngModel)]="tempFee.forFirstArea"></p-inputSwitch>
        </div>
      </div>
    </ng-container>
  </div>

  <div class="save-btn-block">
    <div class="sav-btn-bloock">
      <div class="space-block">
      </div>

      <button mat-button class="save-btn" (click)="saveSub()"
              [disabled]="loadingSpinner || !tempFee.name"
              tabindex="1" type="submit"
              [ngClass]="{'disabled-button': loadingSpinner || !tempFee.name}">

        <span *ngIf="!loadingSpinner">{{footerBtnString}}</span>
        <lib-mini-progress-spinner *ngIf="loadingSpinner"></lib-mini-progress-spinner>
      </button>

      <div class="flex-box">
        <button *ngIf="footerBtnString === 'Save'" mat-button class="delete-task-button" (click)="deleteSub()">
          <mat-icon *ngIf="!deleteLoadingSpinner">delete</mat-icon>
          <lib-mini-progress-spinner *ngIf="deleteLoadingSpinner"></lib-mini-progress-spinner>
        </button>
      </div>

    </div>
  </div>
</div>
<div class="loading-spinner-block" *ngIf="typeLoading">
  <lib-progress-spinner></lib-progress-spinner>
</div>
